// extracted by mini-css-extract-plugin
module.exports = {"header":"Table_header__2gRGf","row":"Table_row__3T2zx","plus":"Table_plus__3_WZD"};